<template lang="pug">
.card.mb-0
  .card-header
    .row.w-100
      .col-md-2.col-2.mb-1
        b-input-group(size="sm")
          b-input-group-text(slot="prepend")
            i.fa.fa-user-tie
          DebounceInput(required autofocus type="text" v-model="searchAffiliateID" :placeholder="$t('message.search_by_account_id')" @enter="getListing()" size="sm")
      .col-md-8.col-8.mb-1
        DateRangePicker(:value="dateRange" @update="getData")
      .col-md-12.col-12.mb-1
        SubmitButton(
          :loading="loading"
          icon="fa fa-search"
          :text="$t('ui.search')"
          type="button"
          @click="getListing()"
          variant="primary"
          size="sm"
        )
  .card-body
    .row
      .col-md-12.col-12
        b-breadcrumb
          b-breadcrumb-item(
            v-if="!isOperator"
            active
          )
            span {{ accountID }}
          b-breadcrumb-item(
            v-if="operatorID"
            active
          )
            span {{ operatorID }} 
          b-breadcrumb-item(
            v-for="(item,index) in lines"
            :key="index"
            :active="!isLineClickable(index)"
            :class="{ active : index == lines.length - 1 && isLineClickable(index) }"
            @click="isLineClickable(index) && drillIn(item, 'affiliate')"
          )
            span {{ item.account_id }}
    .row(v-if="selectedAffiliateAccType < 10")
      .col-12
        .card.card-primary
          .card-header
            i.fa.fa-user-tie
            span.ml-1.font-weight-bold(:title="$t('ui.affiliate')") {{ $t("ui.affiliate") }}
          .card-body
            .row
              .col-md-10.col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRowAff"
                  :per-page="getPageSize"
                  v-model="currentPageAff"
                  @input="changedPageAff($event)")
              .col-md-2.col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeAff" size="sm")
              .col-md-12.col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(rowspan=2 width="3%")
                          span #
                        th(rowspan=2 width="17%" @click="sortOrder('account_id','aff')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id','aff')")
                        th.text-center(colspan=4 width="40%")
                          span(:title="$t('ui.downline')") {{ $t('ui.downline') }}  
                        th.text-center(colspan=4 width="40%")
                          span(:title="$t('ui.member')") {{ $t('ui.member') }}  
                      tr
                        th.text-right(width="10%" @click="sortOrder('turnover_downline','aff')")
                          span(:title="$t('ui.turnover_downline')") {{ $t('ui.turnover') }}
                          .float-right
                            i(:class="changeSortKey('turnover_downline','aff')")
                        th.text-right(width="10%" @click="sortOrder('valid_turnover_downline','aff')")
                          span(:title="$t('ui.valid_turnover_downline')") {{ $t('ui.valid_turnover') }}
                          .float-right
                            i(:class="changeSortKey('valid_turnover_downline','aff')")
                        th.text-right(width="10%" @click="sortOrder('winlose_downline','aff')")
                          span(:title="$t('ui.winlose_downline')") {{ $t('ui.winlose') }}
                          .float-right
                            i(:class="changeSortKey('winlose_downline','aff')")
                        th.text-right(width="10%" @click="sortOrder('bet_count_downline','aff')")
                          span(:title="$t('ui.bet_count_downline')") {{ $t("ui.bet_count") }}
                          .float-right
                            i(:class="changeSortKey('bet_count_downline','aff')")
                        th.text-right(width="8%" @click="sortOrder('turnover_member','aff')")
                          span(:title="$t('ui.turnover_member')") {{ $t("ui.turnover") }}
                          .float-right
                            i(:class="changeSortKey('turnover_member','aff')")
                        th.text-right(width="10%" @click="sortOrder('valid_turnover_member','aff')")
                          span(:title="$t('ui.valid_turnover_member')") {{ $t("ui.valid_turnover") }}
                          .float-right
                            i(:class="changeSortKey('valid_turnover_member','aff')")
                        th.text-right(width="10%" @click="sortOrder('winlose_member','aff')")
                          span(:title="$t('ui.winlose_member')") {{ $t("ui.winlose") }}
                          .float-right
                            i(:class="changeSortKey('winlose_member','aff')")
                        th.text-right(width="10%" @click="sortOrder('bet_count_member','aff')")
                          span(:title="$t('ui.bet_count_member')") {{ $t("ui.bet_count") }}
                          .float-right
                            i(:class="changeSortKey('bet_count_member','aff')")
                    tbody.clusterize-content
                      tr(v-if="affList.length == 0")
                        td(colspan="10").text-center
                          span {{ $t('message.no_data_available') }}
                      template(v-for="(item, index) in affList")
                        tr
                          td.text-center
                            span(:title="((currentPageAff - 1) * getPageSize + index + 1)") {{ ((currentPageAff - 1) * getPageSize + index + 1) }}
                          td
                            span(:title="item.account_id")
                              b-link.clickable(href="javascript:void(0);" @click="drillIn(item, 'affiliate')") {{ item.account_id }}
                              .float-right
                                i.fa.ml-1(:title="$t('ui.detail')" size="sm" @click="onOffDetail(item,'aff')" :class="currIdAff == item.account_id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                          td.text-right
                            span(:title="$n(item.turnover_downline, 'currency')") {{ $n(item.turnover_downline, 'currency') }}
                          td.text-right
                            span(:title="$n(item.valid_turnover_downline, 'currency')") {{ $n(item.valid_turnover_downline, 'currency') }}
                          td.text-right
                            span(:title="$n(item.winlose_downline, 'currency')") {{ $n(item.winlose_downline, 'currency') }}
                          td.text-right
                            span(:title="$n(item.bet_count_downline, 'integer')") {{ $n(item.bet_count_downline, 'integer') }}
                          td.text-right
                            span(:title="$n(item.turnover_member, 'currency')") {{ $n(item.turnover_member, 'currency') }}
                          td.text-right
                            span(:title="$n(item.valid_turnover_member, 'currency')") {{ $n(item.valid_turnover_member, 'currency') }}
                          td.text-right
                            span(:title="$n(item.winlose_member, 'currency')") {{ $n(item.winlose_member, 'currency') }}
                          td.text-right
                            span(:title="$n(item.bet_count_member, 'integer')") {{ $n(item.bet_count_member, 'integer') }}
                          //- td.text-center
                          //-   i.fa.ml-1(:title="$t('ui.detail')" size="sm" @click="onOffDetail(item,'aff')" :class="currIdAff == item.account_id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                        tr(v-if="isShowDetailAff == true && currIdAff == item.account_id")
                          td(colspan="11")
                            .clusterize-scroll.table-responsive
                              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                                thead.thead-dark
                                  tr
                                    th(rowspan=2 width="20%")
                                      span(:title="$t('ui.category')") {{ $t("ui.category") }}
                                    th.text-center(colspan=4 width="40%")
                                      span(:title="$t('ui.downline')") {{ $t('ui.downline') }}  
                                    th.text-center(colspan=4 width="40%")
                                      span(:title="$t('ui.member')") {{ $t('ui.member') }}
                                  tr
                                    th.text-right(width="10%")
                                      span(:title="$t('ui.turnover_downline')") {{ $t("ui.turnover") }} 
                                    th.text-right(width="10%")
                                      span(:title="$t('ui.valid_turnover_downline')") {{ $t("ui.valid_turnover") }}
                                    th.text-right(width="10%")
                                      span(:title="$t('ui.winlose_downline')") {{ $t("ui.winlose") }}
                                    th.text-right(width="10%")
                                      span(:title="$t('ui.bet_count_downline')") {{ $t("ui.bet_count") }}
                                    th.text-right(width="10%")
                                      span(:title="$t('ui.turnover_member')") {{ $t("ui.turnover") }}
                                    th.text-right(width="10%")
                                      span(:title="$t('ui.valid_turnover_member')") {{ $t("ui.valid_turnover") }}
                                    th.text-right(width="10%")
                                      span(:title="$t('ui.winlose_member')") {{ $t("ui.winlose") }}
                                    th.text-right(width="10%")
                                      span(:title="$t('ui.bet_count_member')") {{ $t("ui.bet_count") }}
                                tbody.clusterize-content
                                  tr(v-if="winLoseCatList.length == 0")
                                    td(colspan="9").text-center
                                      span {{ $t('message.no_data_available') }}
                                  tr(v-for="(item, index) in winLoseCatList")
                                    td
                                      span(:title="item.category") {{ item.category }}
                                    td.text-right
                                      span(:title="$n(item.turnover_downline, 'currency')") {{ $n(item.turnover_downline, 'currency') }}
                                    td.text-right
                                      span(:title="$n(item.valid_turnover_downline, 'currency')") {{ $n(item.valid_turnover_downline, 'currency') }}
                                    td.text-right
                                      span(:title="$n(item.winlose_downline, 'currency')") {{ $n(item.winlose_downline, 'currency') }}
                                    td.text-right
                                      span(:title="$n(item.bet_count_downline, 'integer')") {{ $n(item.bet_count_downline, 'integer') }}
                                    td.text-right
                                      span(:title="$n(item.turnover_member, 'currency')") {{ $n(item.turnover_member, 'currency') }}
                                    td.text-right
                                      span(:title="$n(item.valid_turnover_member, 'currency')") {{ $n(item.valid_turnover_member, 'currency') }}
                                    td.text-right
                                      span(:title="$n(item.winlose_member, 'currency')") {{ $n(item.winlose_member, 'currency') }}
                                    td.text-right
                                      span(:title="$n(item.bet_count_member, 'integer')") {{ $n(item.bet_count_member, 'integer') }}
                      tr(v-if="showTotalAff")
                        td.text-right(colspan="2")
                          span {{ $t("ui.sub_total") }}
                          br
                          span {{ $t("ui.grand_total") }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnoverDownline)" :title="$n(subTotalTurnoverDownline, 'currency')") {{ $n(subTotalTurnoverDownline, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnoverDownline)" :title="$n(grandTotalTurnoverDownline, 'currency')") {{ $n(grandTotalTurnoverDownline, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnoverDownline)" :title="$n(subTotalValidTurnoverDownline, 'currency')") {{ $n(subTotalValidTurnoverDownline, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnoverDownline)" :title="$n(grandTotalValidTurnoverDownline, 'currency')") {{ $n(grandTotalValidTurnoverDownline, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLoseDownline)" :title="$n(subTotalWinLoseDownline, 'currency')") {{ $n(subTotalWinLoseDownline, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLoseDownline)" :title="$n(grandTotalWinLoseDownline, 'currency')") {{ $n(grandTotalWinLoseDownline, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalBetCountDownline)" :title="$n(subTotalBetCountDownline, 'integer')") {{ $n(subTotalBetCountDownline, 'integer') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBetCountDownline)" :title="$n(grandTotalBetCountDownline, 'integer')") {{ $n(grandTotalBetCountDownline, 'integer') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnoverMember)" :title="$n(subTotalTurnoverMember, 'currency')") {{ $n(subTotalTurnoverMember, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnoverMember)" :title="$n(grandTotalTurnoverMember, 'currency')") {{ $n(grandTotalTurnoverMember, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnoverMember)" :title="$n(subTotalValidTurnoverMember, 'currency')") {{ $n(subTotalValidTurnoverMember, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnoverMember)" :title="$n(grandTotalValidTurnoverMember, 'currency')") {{ $n(grandTotalValidTurnoverMember, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLoseMember)" :title="$n(subTotalWinLoseMember, 'currency')") {{ $n(subTotalWinLoseMember, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLoseMember)" :title="$n(grandTotalWinLoseMember, 'currency')") {{ $n(grandTotalWinLoseMember, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalBetCountMember)" :title="$n(subTotalBetCountMember, 'integer')") {{ $n(subTotalBetCountMember, 'integer') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBetCountMember)" :title="$n(grandTotalBetCountMember, 'integer')") {{ $n(grandTotalBetCountMember, 'integer') }}

    .row(v-if="selectedAffiliateID") 
      .col-12
        .card.card-secondary
          .card-header
            i.fa.fa-user
            span.ml-1.font-weight-bold(:title="$t('ui.member')") {{ $t("ui.member") }}
          .card-body
            .row
              .col-md-10.col-10.mb-1
                b-pagination.float-left(
                  size="sm"
                  hide-ellipsis
                  :total-rows="totalRowMbm"
                  :per-page="getPageSize"
                  v-model="currentPageMbm"
                  @input="changedPageMbm($event)")
              .col-md-2.col-2.mb-1
                b-input-group(:prepend="$t('ui.page_size')" size="sm")
                  b-form-select(:options="$store.getters.pageSizeOptions" :value="getPageSize" @input="changedPageSizeMbm" size="sm")
              .col-md-12.col-12
                .clusterize-scroll.table-responsive
                  table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                    thead.thead-light
                      tr
                        th.text-center(width="3%")
                          span #
                        th(width="9%" @click="sortOrder('account_id','mbm')")
                          span(:title="$t('ui.account_id')") {{ $t('ui.account_id') }}
                          .float-right
                            i(:class="changeSortKey('account_id','mbm')")
                        th.text-right(width="9%" @click="sortOrder('turnover','mbm')")
                          span(:title="$t('ui.turnover')") {{ $t('ui.turnover') }}
                          .float-right
                            i(:class="changeSortKey('turnover','mbm')")
                        th.text-right(width="8%" @click="sortOrder('valid_turnover','mbm')")
                          span(:title="$t('ui.valid_turnover')") {{ $t('ui.valid_turnover') }}
                          .float-right
                            i(:class="changeSortKey('valid_turnover','mbm')")
                        th.text-right(width="8%" @click="sortOrder('winlose','mbm')")
                          span(:title="$t('ui.winlose')") {{ $t('ui.winlose') }}
                          .float-right
                            i(:class="changeSortKey('winlose','mbm')")
                        th.text-right(width="8%" @click="sortOrder('bet_count','mbm')")
                          span(:title="$t('ui.bet_count')") {{ $t("ui.bet_count") }}
                          .float-right
                            i(:class="changeSortKey('bet_count','mbm')")
                    tbody.clusterize-content
                      tr(v-if="mbmList.length == 0")
                        td(colspan="6").text-center
                          span {{ $t('message.no_data_available') }}
                      template(v-for="(item, index) in mbmList")
                        tr
                          td.text-center
                            span(:title="((currentPageMbm - 1) * getPageSize + index + 1)") {{ ((currentPageMbm - 1) * getPageSize + index + 1) }}
                          td
                            span(:title="item.account_id") {{ item.account_id }}
                            .float-right
                              i.fa.ml-1(:title="$t('ui.detail')" size="sm" @click="onOffDetail(item,'mbm')" :class="currIdMbm == item.account_id ? 'fa-eye-slash text-danger' : 'fa-eye text-success'" style="cursor: pointer;")
                          td.text-right
                            span(:title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                          td.text-right
                            span(:title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                          td.text-right
                            span(:title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                          td.text-right
                            span(:title="$n(item.bet_count, 'integer')") {{ $n(item.bet_count, 'integer') }}
                        tr(v-if="isShowDetailMbm == true && currIdMbm == item.account_id")
                          td(colspan="6")
                            .clusterize-scroll.table-responsive
                              table.table.table-sm.table-bordered.table-striped.table-hover.table-align-middle
                                thead.thead-dark
                                  tr
                                    th(width="9%")
                                      span(:title="$t('ui.category')") {{ $t("ui.category") }}
                                    th.text-right(width="9%")
                                      span(:title="$t('ui.turnover')") {{ $t("ui.turnover") }}
                                    th.text-right(width="9%")
                                      span(:title="$t('ui.valid_turnover')") {{ $t("ui.valid_turnover") }}
                                    th.text-right(width="9%")
                                      span(:title="$t('ui.winlose')") {{ $t("ui.winlose") }}
                                    th.text-right(width="9%")
                                      span(:title="$t('ui.bet_count')") {{ $t("ui.bet_count") }}
                                tbody.clusterize-content
                                  tr(v-if="winLoseMbmCatList.length == 0")
                                    td(colspan="5").text-center
                                      span {{ $t('message.no_data_available') }}
                                  tr(v-for="(item, index) in winLoseMbmCatList")
                                    td
                                      span(:title="item.category") {{ item.category }}
                                    td.text-right
                                      span(:title="$n(item.turnover, 'currency')") {{ $n(item.turnover, 'currency') }}
                                    td.text-right
                                      span(:title="$n(item.valid_turnover, 'currency')") {{ $n(item.valid_turnover, 'currency') }}
                                    td.text-right
                                      span(:title="$n(item.winlose, 'currency')") {{ $n(item.winlose, 'currency') }}
                                    td.text-right
                                      span(:title="$n(item.bet_count, 'integer')") {{ $n(item.bet_count, 'integer') }}
                      tr(v-if="showTotalMbm")
                        td.text-right(colspan="2")
                          span {{ $t("ui.sub_total") }}
                          br
                          span {{ $t("ui.grand_total") }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalTurnover)" :title="$n(subTotalTurnover, 'currency')") {{ $n(subTotalTurnover, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalTurnover)" :title="$n(grandTotalTurnover, 'currency')") {{ $n(grandTotalTurnover, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalValidTurnover)" :title="$n(subTotalValidTurnover, 'currency')") {{ $n(subTotalValidTurnover, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalValidTurnover)" :title="$n(grandTotalValidTurnover, 'currency')") {{ $n(grandTotalValidTurnover, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalWinLose)" :title="$n(subTotalWinLose, 'currency')") {{ $n(subTotalWinLose, 'currency') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalWinLose)" :title="$n(grandTotalWinLose, 'currency')") {{ $n(grandTotalWinLose, 'currency') }}
                        td.text-right
                          span.font-weight-bold(:class="$helpers.fontClassName(subTotalBetCount)" :title="$n(subTotalBetCount, 'integer')") {{ $n(subTotalBetCount, 'integer') }}
                          br
                          span.font-weight-bold(:class="$helpers.fontClassName(grandTotalBetCount)" :title="$n(grandTotalBetCount, 'integer')") {{ $n(grandTotalBetCount, 'integer') }}

</template>

<script>
import config from "@/config";
import errorTags from "@/errorTags";
import SubmitButton from "@/library/SubmitButton.vue";
import DebounceInput from "@/library/DebounceInput";
import DateRangePicker from "@/library/DateRangePicker.vue";
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css';

export default {
  components: {
    SubmitButton,
    DebounceInput,
    DateRangePicker
  },
  props: {
    selectedAffiliateId: {
      type: String,
      default: ''
    },
    sharedLines: {
      type: Array,
      default: () => []
    }
  },
  data: () => ({
    loading: false,
    affList: [],
    mbmList: [],
    lines: [],
    winLoseCatList: [],
    winLoseMbmCatList: [],
    currentPageAff: 1,
    totalRowAff: 0,
    currentPageMbm: 1,
    totalRowMbm: 0,
    searchAffiliateID: "",
    selectedAffiliateID: "",
    selectedAffiliateAccType: "",
    dateRange: {
      startDate: null,
      endDate: null
    },
    feedback: {
      success: false,
      status: errorTags.request.failed
    },
    sortKeyAff: "account_id",
    sortTypeAff: "asc",
    sortKeyMbm: "account_id",
    sortTypeMbm: "asc",
    currIdAff: null,
    isShowDetailAff: false,
    currIdMbm: null,
    isShowDetailMbm: false,
    showTotalAff: false,
    showTotalMbm: false,
    subTotalTurnoverDownline: 0,
    grandTotalTurnoverDownline: 0,
    subTotalValidTurnoverDownline: 0,
    grandTotalValidTurnoverDownline: 0,
    subTotalWinLoseDownline: 0,
    grandTotalWinLoseDownline: 0,
    subTotalBetCountDownline: 0,
    grandTotalBetCountDownline: 0,
    subTotalTurnoverMember: 0,
    grandTotalTurnoverMember: 0,
    subTotalValidTurnoverMember: 0,
    grandTotalValidTurnoverMember: 0,
    subTotalWinLoseMember: 0,
    grandTotalWinLoseMember: 0,
    subTotalBetCountMember: 0,
    grandTotalBetCountMember: 0,
    subTotalTurnover: 0,
    grandTotalTurnover: 0,
    subTotalValidTurnover: 0,
    grandTotalValidTurnover: 0,
    subTotalWinLose: 0,
    grandTotalWinLose: 0,
    subTotalBetCount: 0,
    grandTotalBetCount: 0
  }),
  computed: {
    getPageSize() {
      return this.$store.getters.pageSize;
    },
    accountID() {
      return this.$store.getters.accountId;
    },
    operatorID() {
      return this.$store.getters.selectedOperatorID
    },
    affiliateID() {
      return this.$store.getters.selectedAffiliateID
    },
    isOperator() {
      return [2].includes(this.$store.getters.accountType);
    },
    anchorAffiliateIndex() {
      if (!this.lines.length || !this.selectedAffiliateId) return -1;
      return this.lines.findIndex(item => item.account_id === this.selectedAffiliateId);
    },
  },
  mounted: function() {
    if (this.sharedLines.length) {
      this.lines = [...this.sharedLines];
    }
    this.dateRange.startDate = this.$moment(new Date).format('YYYY-MM-DD');
    this.dateRange.endDate = this.$moment(new Date).format('YYYY-MM-DD');

    // this.getListing();
  },
  methods: {
    refresh() {
      this.getListing(true);
    },
    getListing() {
      if (this.checkDateRange()) {
        this.getWinLoseAff(true);
        this.getWinLoseMbm(true);
      } else {
        this.clearTotalAff();
        this.clearTotalMbm();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    onOffDetail(item, type) {
      if (type == 'aff') {
        if (this.isShowDetailAff == true) {
          if (this.currIdAff == item.account_id) {
            this.isShowDetailAff = false;
            this.currIdAff = null;
          } else {
            this.isShowDetailAff = false;
            this.currIdAff = null;
            this.isShowDetailAff = true;
            this.currIdAff = item.account_id;
            this.getWinLoseCategoryAff(item);
          }
        } else {
          this.isShowDetailAff = true;
          this.currIdAff = item.account_id;
          this.getWinLoseCategoryAff(item);
        }
      } else if (type == 'mbm') {
        if (this.isShowDetailMbm == true) {
          if (this.currIdMbm == item.account_id) {
            this.isShowDetailMbm = false;
            this.currIdMbm = null;
          } else {
            this.isShowDetailMbm = false;
            this.currIdMbm = null;
            this.isShowDetailMbm = true;
            this.currIdMbm = item.account_id;
            this.getWinLoseMbmCategoryAff(item);
          }
        } else {
          this.isShowDetailMbm = true;
          this.currIdMbm = item.account_id;
          this.getWinLoseMbmCategoryAff(item);
        }
      }
    },
    sortOrder(key, type) {
      if (type == 'aff') {
        if (this.sortKeyAff == key)
          this.sortTypeAff = this.sortTypeAff == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyAff = key;
          this.sortTypeAff = 'asc';
        }
        this.getWinLoseAff(true);
      } else if (type == 'mbm') {
        if (this.sortKeyMbm == key)
          this.sortTypeMbm = this.sortTypeMbm == 'asc' ? 'desc' : 'asc';
        else {
          this.sortKeyMbm = key;
          this.sortTypeMbm = 'asc';
        }
        this.getWinLoseMbm(true);
      }
    },
    changeSortKey(key, type) {
      if (type == 'aff') {
        if (this.sortKeyAff != key)
          return 'fas fa-sort';
        else if (this.sortKeyAff == key && this.sortTypeAff == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyAff == key && this.sortTypeAff == 'desc')
          return 'fa fa-sort-down';
      } else if (type == 'mbm') {
        if (this.sortKeyMbm != key)
          return 'fas fa-sort';
        else if (this.sortKeyMbm == key && this.sortTypeMbm == 'asc')
          return 'fa fa-sort-up';
        else if (this.sortKeyMbm == key && this.sortTypeMbm == 'desc')
          return 'fa fa-sort-down';
      }
    },
    checkDateRange() {
      if (this.$moment(this.dateRange.endDate).diff(this.$moment(this.dateRange.startDate), 'days') > 31)
        return false;
      else
        return true;
    },
    getData(currentValue) {
      this.dateRange.startDate = this.$moment(currentValue.startDate).format('YYYY-MM-DD');
      this.dateRange.endDate = this.$moment(currentValue.endDate).format('YYYY-MM-DD');
      this.getListing();
    },
    isLineClickable(index) {
      return this.anchorAffiliateIndex >= 0 && index === this.anchorAffiliateIndex;
    },
    syncAffiliateLines() {
      if (this.lines.length > 0) {
        this.$emit('affiliate-lines-update', this.lines);
      }
    },
    drillIn: function (item, mode, id) {
      this.affList = ""
      this.showTotalAff = false
      this.mbmList = ""
      this.showTotalMbm = false

      if(item == 'company') {
        this.selectedAffiliateID = this.selectedAffiliateId;
      }

      if(mode == 'operator') {
        this.selectedAffiliateID = this.selectedAffiliateId;
      }

      if(mode == 'affiliate') {
        let currentAffType = this.lines[this.lines.length-1].account_type
        let selectedAffType = item.account_type
        if(selectedAffType < currentAffType) {
          this.selectedAffiliateID = this.selectedAffiliateId;
        } else {
          this.selectedAffiliateID = item.account_id;
        }
      }

      this.searchAffiliateID = ""
      this.getListing();
    },
    clearTotalAff() {
      this.showTotalAff = false
      this.affList = []
      this.totalRowAff = 0
      this.subTotalTurnoverDownline = 0
      this.grandTotalTurnoverDownline = 0
      this.subTotalValidTurnoverDownline = 0
      this.grandTotalValidTurnoverDownline = 0
      this.subTotalWinLoseDownline = 0
      this.grandTotalWinLoseDownline = 0
      this.subTotalBetCountDownline = 0
      this.grandTotalBetCountDownline = 0
      this.subTotalTurnoverMember = 0
      this.grandTotalTurnoverMember = 0
      this.subTotalValidTurnoverMember = 0
      this.grandTotalValidTurnoverMember = 0
      this.subTotalWinLoseMember = 0
      this.grandTotalWinLoseMember = 0
      this.subTotalBetCountMember = 0
      this.grandTotalBetCountMember = 0
      this.winLoseCatList = []
      this.currIdAff = null
      this.isShowDetailAff = false
    },
    clearTotalMbm() {
      this.showTotalMbm = false
      this.mbmList = []
      this.totalRowMbm = 0
      this.subTotalTurnover = 0
      this.grandTotalTurnover = 0
      this.subTotalValidTurnover = 0
      this.grandTotalValidTurnover = 0
      this.subTotalWinLose = 0
      this.grandTotalWinLose = 0
      this.subTotalBetCount = 0
      this.grandTotalBetCount = 0
      this.winLoseMbmCatList = []
      this.currIdMbm = null
      this.isShowDetailMbm = false
    },
    getWinLoseAff: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.dailyWinLoseAffUrl();

        if (isSearch) this.currentPageAff = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          search_id: this.selectedAffiliateID ? this.selectedAffiliateID : this.affiliateID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKeyAff,
          sort_type: this.sortTypeAff,
          page_number: this.currentPageAff,
          page_size: this.getPageSize,
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalAff()
            this.loading = false;
            // Success
            try {
              if (response) {
                this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

                this.feedback.status = response.data.statusdesc;
                if (this.feedback.success == true) {
                  if(response.data.ds.winlose.length > 0) {
                    this.showTotalAff = true;
                    response.data.ds.winlose.forEach(value => {
                      this.subTotalTurnoverDownline = parseFloat(this.subTotalTurnoverDownline) + parseFloat(value["turnover_downline"]);
                      this.subTotalValidTurnoverDownline = parseFloat(this.subTotalValidTurnoverDownline) + parseFloat(value["valid_turnover_downline"]);
                      this.subTotalWinLoseDownline = parseFloat(this.subTotalWinLoseDownline) + parseFloat(value["winlose_downline"]);
                      this.subTotalBetCountDownline = parseInt(this.subTotalBetCountDownline) + parseInt(value["bet_count_downline"]);
                      this.subTotalTurnoverMember = parseFloat(this.subTotalTurnoverMember) + parseFloat(value["turnover_member"]);
                      this.subTotalValidTurnoverMember = parseFloat(this.subTotalValidTurnoverMember) + parseFloat(value["valid_turnover_member"]);
                      this.subTotalWinLoseMember = parseFloat(this.subTotalWinLoseMember) + parseFloat(value["winlose_member"]);
                      this.subTotalBetCountMember = parseInt(this.subTotalBetCountMember) + parseInt(value["bet_count_member"]);
                    });

                    if(response.data.ds.grand_total.length > 0) {
                      this.grandTotalTurnoverDownline = response.data.ds.grand_total[0]["turnover_downline"];
                      this.grandTotalValidTurnoverDownline = response.data.ds.grand_total[0]["valid_turnover_downline"];
                      this.grandTotalWinLoseDownline = response.data.ds.grand_total[0]["winlose_downline"];
                      this.grandTotalBetCountDownline = response.data.ds.grand_total[0]["bet_count_downline"];
                      this.grandTotalTurnoverMember = response.data.ds.grand_total[0]["turnover_member"];
                      this.grandTotalValidTurnoverMember = response.data.ds.grand_total[0]["valid_turnover_member"];
                      this.grandTotalWinLoseMember = response.data.ds.grand_total[0]["winlose_member"];
                      this.grandTotalBetCountMember = response.data.ds.grand_total[0]["bet_count_member"];
                    }

                    this.affList = response.data.ds.winlose;
                    this.totalRowAff = response.data.ds.winlose.length > 0 ? this.affList[0].totalrows : 0;
                  } else {
                    this.clearTotalAff()
                  }
                  if (response.data.ds.line.length > 0) {
                    this.lines = response.data.ds.line.sort(function(a, b) {
                      return a.account_type - b.account_type;
                    });
                    if(this.selectedAffiliateID) {
                      let list = this.lines.find(item => item.account_id === this.selectedAffiliateID);
                      this.selectedAffiliateAccType = list.account_type;
                    }
                    this.syncAffiliateLines();
                  } else {
                    this.lines = [];
                    this.selectedAffiliateAccType = "";
                  }
                } else {
                  this.clearTotalAff()
                  if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
                }
              }
            } catch (error) {
              this.feedback.success = false;
              this.feedback.status = errorTags.request.failed;
              this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );
      } else {
        this.clearTotalAff();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getWinLoseCategoryAff: function(item) {
      let url = config.dailyWinLoseCategoryAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        account_id: item.account_id,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.winLoseCatList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    getWinLoseMbm: function(isSearch) {
      if (this.checkDateRange()) {
        let url = config.dailyWinLoseMemberAffUrl();

        if (isSearch) this.currentPageMbm = 1;

        var json = {
          action_by: this.$store.getters.loginId,
          auth_token: this.$store.getters.sessionToken,
          operator_id: this.operatorID,
          account_id: this.selectedAffiliateID ? this.selectedAffiliateID : this.affiliateID,
          search_id: this.searchAffiliateID,
          start_date: this.dateRange.startDate,
          end_date: this.dateRange.endDate,
          sort_key: this.sortKeyMbm,
          sort_type: this.sortTypeMbm,
          page_number: this.currentPageMbm,
          page_size: this.getPageSize,
        };

        this.loading = true;
        this.$http.post(url, json).then(
          function(response) {
            this.clearTotalMbm()
            this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

            this.feedback.status = response.data.statusdesc;
            if (this.feedback.success == true) {
              if(response.data.ds.winlose.length > 0) {
                this.showTotalMbm = true;
                response.data.ds.winlose.forEach(value => {
                  this.subTotalTurnover = parseFloat(this.subTotalTurnover) + parseFloat(value["turnover"]);
                  this.subTotalValidTurnover = parseFloat(this.subTotalValidTurnover) + parseFloat(value["valid_turnover"]);
                  this.subTotalWinLose = parseFloat(this.subTotalWinLose) + parseFloat(value["winlose"]);
                  this.subTotalBetCount = parseInt(this.subTotalBetCount) + parseInt(value["bet_count"]);
                });

                if(response.data.ds.grand_total.length > 0) {
                  this.grandTotalTurnover = response.data.ds.grand_total[0]["turnover"];
                  this.grandTotalValidTurnover = response.data.ds.grand_total[0]["valid_turnover"];
                  this.grandTotalWinLose = response.data.ds.grand_total[0]["winlose"];
                  this.grandTotalBetCount = response.data.ds.grand_total[0]["bet_count"];
                }

                this.mbmList = response.data.ds.winlose;
                this.totalRowMbm = response.data.ds.winlose.length > 0 ? this.mbmList[0].totalrows : 0;
              } else {
                this.clearTotalMbm()
              }
            } else {
              this.clearTotalMbm()
              if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
            }
          },
          function(response) {
            this.loading = false;
            // Error
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        );

      } else {
        this.clearTotalMbm();
        this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error.dateRangeAllowOneMonth"), "error");
      }
    },
    getWinLoseMbmCategoryAff: function(item) {
      let url = config.dailyWinLoseMemberCategoryAffUrl();

      var json = {
        action_by: this.$store.getters.loginId,
        auth_token: this.$store.getters.sessionToken,
        operator_id: this.operatorID,
        member_id: item.account_id,
        start_date: this.dateRange.startDate,
        end_date: this.dateRange.endDate
      };

      this.loading = true;
      this.$http.post(url, json).then(
        function(response) {
          this.loading = false;
          // Success
          try {
            if (response) {
              this.feedback.success = typeof response.data.status == "string" ? response.data.status == "1" : response.data.status == 1;

              this.feedback.status = response.data.statusdesc;
              if (this.feedback.success == true) {
                this.winLoseMbmCatList = response.data.dt;
              } else {
                if (!this.$helpers.handleFeedback(this.feedback.status)) this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
              }
            }
          } catch (error) {
            this.feedback.success = false;
            this.feedback.status = errorTags.request.failed;
            this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
          }
        },
        function(response) {
          this.loading = false;
          // Error
          this.feedback.success = false;
          this.feedback.status = errorTags.request.failed;
          this.$helpers.showDialog(this.$t("ui.alert"), this.$t("error." + this.feedback.status), "error");
        }
      );
    },
    changedPageSizeAff: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageAff = 1;
      this.getWinLoseAff(true);
    },
    changedPageAff: function(pageNo) {
      this.currentPageAff = pageNo;
      this.getWinLoseAff();
    },
    changedPageSizeMbm: function(pageSize) {
      this.$store.dispatch("layout/setPageSize", pageSize);
      this.currentPageMbm = 1;
      this.getWinLoseMbm(true);
    },
    changedPageMbm: function(pageNo) {
      this.currentPageMbm = pageNo;
      this.getWinLoseMbm();
    },
    handleFailed: function(tag, status) {
      this.$helpers.showDialog(this.$t("ui.combine." + tag), this.$t("error." + status), "error");
    }
  }
};
</script>